// Site-wide content: settings, home sections, about page content.
// Stored as key/value JSON rows in `site_content` so admins can edit copy.

import { crudFor } from "./dataClient";
import { normalizeSettings } from "@/lib/settings";
import { seedSiteSettings, seedHomeSections, seedAboutContent } from "@/data/seed/siteContent";

const seedRows = [
  { id: "seed-sc-settings", key: "settings", content: seedSiteSettings },
  { id: "seed-sc-home", key: "home_sections", content: seedHomeSections },
  { id: "seed-sc-about", key: "about", content: seedAboutContent },
];

const contentCrud = crudFor("site_content", seedRows);

async function getContent(key, seedDefault) {
  const row = await contentCrud.getBy("key", key);
  return { ...seedDefault, ...(row?.content || {}) };
}

export const contentService = {
  getSettings: async () => normalizeSettings(await getContent("settings", seedSiteSettings)),
  getHomeSections: () => getContent("home_sections", seedHomeSections),
  getAbout: () => getContent("about", seedAboutContent),

  async saveContent(key, content) {
    const existing = await contentCrud.getBy("key", key);
    if (existing) return contentCrud.update(existing.id, { content });
    return contentCrud.create({ key, content });
  },
};
